var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('k-card',[_c('v-card-title',[_vm._v(" Grafik ")]),_c('v-card-text',[_c('bar-chart',_vm._b({},'bar-chart',_vm.barChartProps,false))],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }